import { Plugins } from "@capacitor/core";
import axios from "axios";
import store from "../store";
import { setLogin } from "@acri-tools/react-tools/actions";

// axios.interceptors.request.use(async (config) => {
//     try {
//         const { value: token } = await Plugins.Storage.get({ key: 'user_token' });
//         if (token) {
//             config.headers = config.headers || {};
//             config.headers['Authorization'] = `Bearer ${token}`;
//         }
//     } catch (e) {
//         console.error("Failed to retrieve user_token from storage", e);
//     }
//     return config;
// }, (error) => {
//     return Promise.reject(error);
// });


// Add a request interceptor to the global axios object
axios.interceptors.request.use(async (config) => {
    console.log("Request URL:", config?.url);
    let user;
    let user_token;
    try {
        user = await store.getState().login.user;   
        user_token = (await Plugins.Storage.get({ key: 'user_token' })).value;
    }
    catch(e){
        console.error("Failed to retrieve user_token from storage", e);
    } 
    if (
        ( !user && user_token )
        || 
        ( config.url && config.url.includes('/api/user-manager/v1/logout') )
    ) {
        console.log("Got in to remove due to user_token existing but not user");
        await Plugins.Storage.remove({ key: 'user_token' });
    }
    if (
        config.url && !(config.url.includes('/api/user-manager/v1/login') || config.url.includes('/api/user-manager/v1/logout'))
    ) {
        console.log("Got in login or logout");
        if (user_token) {
            config.headers = config.headers || {};
            config.headers['Authorization'] = `Bearer ${user_token}`;
        }
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

axios.interceptors.response.use(
    async (response) => {
        // Check if this is a logout response (success case)
        if (
            response?.config?.url &&
            response.config.url.includes('/api/user-manager/v1/logout')
        ) {
            try {
                await Plugins.Storage.remove({ key: 'user_token' });
                store.dispatch(setLogin({ user: null }));
                console.log("user_token removed from storage after logout response");
            } catch (e) {
                console.error("Failed to remove user_token from storage after logout", e);
            }
        }
        return response;
    },
    async (error) => {
        // Also handle logout in error responses
        const config = error?.config;
        if (
            config?.url &&
            config.url.includes('/api/user-manager/v1/logout')
        ) {
            try {
                await Plugins.Storage.remove({ key: 'user_token' });
                store.dispatch(setLogin({ user: null }));
                console.log("user_token removed from storage after logout error response");
            } catch (e) {
                console.error("Failed to remove user_token from storage after logout (error case)", e);
            }
        }
        return Promise.reject(error);
    }
);

